<!-- 资质情况表 -->

<template>
  <div class="tabCage table4E">
    <div class="tabTtl">
      <span>表 1-4：经营场所情况表</span>
    </div>
    <!-- <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div> -->
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">场所情况：</td>
            <td class="edInp edSelect">
              <el-form-item prop="placePower" :inline-message="true">
                <el-select v-model="params.placePower" size="small" placeholder="请选择场所情况">
                  <el-option v-for="item in dicDats['C020']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="dicMap['C020'][params.placePower] == '其他'" prop="otherPower" :inline-message="true">
                <el-input v-model="params.otherPower" size="small"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">场所所有权：</td>
            <td class="edInp edSelect">
              <el-form-item prop="placeSituation" :inline-message="true">
                <el-select v-model="params.placeSituation" size="small" placeholder="请选择场所所有权">
                  <el-option v-for="item in dicDats['C002']" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="dicMap['C002'][params.placeSituation] == '其他'"
                prop="otherSituation"
                :inline-message="true">
                <el-input v-model="params.otherSituation" size="small"></el-input>
              </el-form-item>
            </td>
            <td></td>
          </tr>
          <tr>
            <td class="edName">面积（平米）：</td>
            <td class="edInp">
              <el-form-item prop="placeArea" :show-message="false">
                <el-input-number
                  v-model="params.placeArea"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInpTextArea">
              <el-form-item prop="remark" :inline-message="true">
                <el-input type="textarea" :rows="3" v-model="params.remark" size="small"></el-input>
              </el-form-item>
              <!-- <el-input type="textarea" :rows="4" v-model="params.remark" size="small"></el-input> -->
            </td>
          </tr>
        </table>
      </el-form>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="pubStatus == 0" type="primary" @click="editSave('paramCk')" size="small">保存</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt4";
import { tabUpdate4, tabRead4 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,
      dicDats: {},
      dicMap: {
        C002: {},
        C020: {},
      },
      pubStatus: 0,
    };
  },
  methods: {
    editSave: function (name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;

          tabUpdate4({
            // pplace: this.params,
            // 模组化
            data: this.params,
            // 身份验证要用
            publishMaterialId: this.params.publishMaterialId,
          })
            .then((response) => {
              let tipCode = response.payload.pplace.code;
              let tipMessage = response.payload.pplace.message;

              that.submiting = false;
              if (tipCode == -1) {
                that.$message.error(`保存错误: ${tipMessage}`);
                return;
              }
              this.$message({
                message: "保存成功！",
                type: "success",
              });

              this.goBack();
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    dictInit: function () {
      let nameArr = ["C002", "C020"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C002"] = this.$store.getters.dictionary["C002"];
        this.dicMap["C020"] = this.$store.getters.dictionary["C020"];
      });
    },

    tabReEdit: function () {
      tabRead4({ id: this.$route.query.id }).then((response) => {
        this.params = response.pplace;
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
    if (this.$route.query.pgress == 2) {
      this.tabReEdit();
    }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table4E {
  .edInp {
    .el-input-number {
      width: 300px;
    }

    .el-input-number {
      width: 300px;
    }

    .el-textarea {
      width: 450px;
    }
  }

  .edSelect .el-form-item {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// table4.vue?61fff041